import React from "react";

const Sk: React.FC<{ w?: number | string; h?: number; r?: number; style?: React.CSSProperties }> = ({
  w = "100%", h = 14, r = 7, style,
}) => (
  <div className="sk" style={{ width: w, height: h, borderRadius: r, flexShrink: 0, ...style }} />
);

const skRow = (n: number) =>
  Array.from({ length: n }, (_, i) => (
    <div key={i} style={{ display: "grid", gridTemplateColumns: "minmax(80px,120px) 1fr 56px", gap: 10, alignItems: "center" }}>
      <Sk h={12} r={6} />
      <Sk h={7} r={4} />
      <Sk w={38} h={12} r={6} style={{ marginLeft: "auto" }} />
    </div>
  ));

export const ReportSkeleton: React.FC = () => (
  <div className="report-page">

    {/* profile */}
    <div className="rp-sec">
      <div style={{ display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap" }}>
        <Sk w={80} h={80} r={50} />
        <div style={{ flex: 1, minWidth: 180, display: "flex", flexDirection: "column", gap: 11, paddingTop: 8 }}>
          <Sk w={170} h={20} r={8} />
          <Sk w={120} h={14} r={6} />
          <Sk w="80%" h={12} r={6} />
          <Sk w="55%" h={12} r={6} />
        </div>
        <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
          <Sk w={148} h={44} r={999} />
          <Sk w={148} h={44} r={999} />
        </div>
      </div>
    </div>

    {/* summary */}
    <div className="rp-sec rp-sec-tinted">
      <Sk w={80} h={12} r={6} style={{ marginBottom: 10 }} />
      <Sk w={240} h={22} r={8} style={{ marginBottom: 24 }} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 13 }}>
        {Array.from({ length: 7 }, (_, i) => (
          <div key={i} className="sk" style={{ height: 78, borderRadius: 18 }} />
        ))}
      </div>
    </div>

    {/* engagement */}
    <div className="rp-sec">
      <Sk w={200} h={22} r={8} style={{ marginBottom: 24 }} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 13 }}>
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="sk" style={{ height: 104, borderRadius: 18 }} />
        ))}
      </div>
    </div>

    {/* audience */}
    <div className="rp-sec rp-sec-tinted">
      <Sk w={180} h={22} r={8} style={{ marginBottom: 24 }} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>{skRow(7)}</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>{skRow(7)}</div>
      </div>
    </div>

    {/* posts */}
    <div className="rp-sec" style={{ borderBottom: "none" }}>
      <Sk w={120} h={22} r={8} style={{ marginBottom: 24 }} />
      <Sk h={240} r={18} />
    </div>

  </div>
);
